export type InterventionPriorite = "faible" | "normale" | "elevee" | "urgente";

export type InterventionStatut = "nouveau" | "en-cours" | "en-attente" | "termine" | "annule";

export interface Intervention {
  id: string;
  immeubleId: string;
  bienId: string;
  probleme: string;
  description: string;
  priorite: InterventionPriorite;
  statut: InterventionStatut;
  photos: string[];
  cout: number;
  prestataire: string;
  date: string;
  createdAt: string;
}

export type InterventionInput = Omit<Intervention, "id" | "createdAt">;

export const INTERVENTION_PRIORITE_LABELS: Record<InterventionPriorite, string> = {
  faible: "Faible",
  normale: "Normale",
  elevee: "Élevée",
  urgente: "Urgente",
};

export const INTERVENTION_PRIORITE_ICONS: Record<InterventionPriorite, string> = {
  faible: "ri-arrow-down-line",
  normale: "ri-subtract-line",
  elevee: "ri-arrow-up-line",
  urgente: "ri-alarm-warning-line",
};

export const INTERVENTION_PRIORITE_TONES: Record<
  InterventionPriorite,
  "primary" | "accent" | "secondary" | "neutral" | "danger"
> = {
  faible: "neutral",
  normale: "secondary",
  elevee: "accent",
  urgente: "danger",
};

export const INTERVENTION_PRIORITE_OPTIONS = (
  Object.keys(INTERVENTION_PRIORITE_LABELS) as InterventionPriorite[]
).map((value) => ({ value, label: INTERVENTION_PRIORITE_LABELS[value] }));

export const INTERVENTION_STATUT_LABELS: Record<InterventionStatut, string> = {
  nouveau: "Nouveau",
  "en-cours": "En cours",
  "en-attente": "En attente",
  termine: "Terminé",
  annule: "Annulé",
};

export const INTERVENTION_STATUT_ICONS: Record<InterventionStatut, string> = {
  nouveau: "ri-add-circle-line",
  "en-cours": "ri-loader-4-line",
  "en-attente": "ri-time-line",
  termine: "ri-checkbox-circle-line",
  annule: "ri-close-circle-line",
};

export const INTERVENTION_STATUT_TONES: Record<
  InterventionStatut,
  "primary" | "accent" | "secondary" | "neutral" | "danger"
> = {
  nouveau: "primary",
  "en-cours": "accent",
  "en-attente": "neutral",
  termine: "secondary",
  annule: "danger",
};

export const INTERVENTION_STATUT_OPTIONS = (
  Object.keys(INTERVENTION_STATUT_LABELS) as InterventionStatut[]
).map((value) => ({ value, label: INTERVENTION_STATUT_LABELS[value] }));

/**
 * Modèle de données prévu pour Supabase.
 * Table cible : `interventions`
 *   id uuid primary key default gen_random_uuid()
 *   owner_id uuid references auth.users(id)
 *   immeuble_id uuid references immeubles(id) on delete set null
 *   bien_id uuid references biens(id) on delete set null
 *   probleme text not null, description text
 *   priorite text default 'normale', statut text default 'nouveau'
 *   photos text[] default '', cout numeric default 0
 *   prestataire text, date date not null
 *   created_at timestamptz default now()
 */